<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="rounded-md bg-yellow-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <i class="fa-solid fa-triangle-exclamation h-5 w-5 text-yellow-400" aria-hidden="true"></i>
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-yellow-800"> {{ warning_data.title }}</h3>
        
        <div v-if="warning_data.message" class="mt-2 text-sm text-yellow-700">
          <p>{{ warning_data.message }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertWarning",
  components: {  },
  props: ["warning_data"],
  data() {
    return {
      
    };
  },
};
</script>